import { css } from '@emotion/react';
import { Animation, Colors, Link, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../../utils/avroEvents';
import { ArrowLinkIcon } from '../..';
const Styles = labelStyles('SubMenuList', {
    root: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    item: Object.assign(Object.assign({ marginBottom: '10px' }, Typography.paragraph3), { '&:last-child': {
            marginBottom: 0,
        }, '&:focus-within': {
            outline: `1px solid ${Colors.blue}`,
        } }),
    link: css(Object.assign(Object.assign({ color: Colors.neutral700 }, Typography.paragraph3), { position: 'relative', textDecoration: 'none', transition: `text-decoration 100ms ${Animation.transitionTimingFunction}`, '&:hover': {
            textDecoration: 'underline',
        }, '&:hover > span': {
            marginLeft: 4,
            opacity: 1,
        }, '&:focus': {
            outline: 'none',
        } })),
});
export const SubMenuList = (props) => {
    const { submenu } = props;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `MegaMenuSubmenuLink: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return (isolateComponent("ul", { css: Styles.root }, submenu.map((link, index) => (isolateComponent("li", { css: Styles.item, key: `${link.text}-${index}` },
        isolateComponent(Link, { css: Styles.link, color: null, href: getFullyQualifiedURL(link.href) || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
            link.text,
            isolateComponent(ArrowLinkIcon, null)))))));
};
//# sourceMappingURL=SubMenuList.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
